import controller from './shop.controller';
import template from './shop.html';

const shopComponent = {
  restrict: 'E',
  bindings: {},
  template,
  controller
};

export default shopComponent;



/** WEBPACK FOOTER **
 ** ./client/app/components/shop/shop.component.js
 **/